<template>
  <div class="bandeau-image">
    <a :href="lien" :title="alt" class="image"><img :src="imagePath" :alt="alt" :title="alt"/></a>
    <p><slot></slot></p>
  </div> 
            
</template>

<script>
  export default {
    props: ['lien', 'imagePath'],
    computed: {
      alt () {
        let explodedPath =  this.imagePath.split('/')
        let imageName = explodedPath[explodedPath.length - 1]
        return imageName.split('.')[0]
      }
    }
  }
</script>

<style>
  .bandeau-image {
    width: 100%;
    background: white;
    border-radius: 15px;
    padding: 30px;
    box-shadow: 0px 0px 15px rgba(0,0,0,0.2);
    margin-top: 20px;  
    margin-bottom: 40px;  
  }
  .bandeau-image a.image { float: left; }
  .bandeau-image p { display: inline-block; max-width: 300px;}
</style>
